import "./PharmaceuticalsSuccessCase.module.css";
import Header from "@/reusable_sections/Header";
import Pharmahero from "./sections/Pharmahero";
import Intelligence from "./sections/Intelligence";
import Sustainability from "./sections/Sustainability";
import Consultation from "./sections/Consultation";
import Footer from "@/reusable_sections/Footer";
export default function PharmaceuticalsSuccessCasePage() {
  return <div>
      <Header />
      <Pharmahero />
      <Intelligence />
      <Sustainability />
      <Consultation />
      <Footer />
    </div>;
}